

import { Tools } from '@/views/viewsFunction/designerMethods'

export class FuncEvents {
    static getMobileUserinfo() {
        try {
            let mobileUserinfoStorage = localStorage.getItem('mobileUserinfo') || {}
            let mobileUserinfo = JSON.parse(mobileUserinfoStorage)

            return mobileUserinfo
        } catch (error) {
            console.error('获取 getMobileUserinfo 失败:', error)
            return {}
        }

    }

    static getUserInfo() {
        return '8510000'
    }
    static getJGM() {
        const { commOrgIdenty } = FuncEvents.getMobileUserinfo()

        if (commOrgIdenty) {
            return commOrgIdenty || ""
        } else {
            Login.goToWXPage({ url: '/pages/xd-yytPage/water-login' })
        }
    }
    /**
     * @title 获取用户id
     * @returns 用户id
     */
    static getUserId() {
        const { userId } = FuncEvents.getMobileUserinfo()
        if (userId) {
            return userId || ""
        } else {
            Login.goToWXPage({ url: '/pages/xd-yytPage/water-login' })
            return false
        }
    }
    /**
     * @title 获取用户地址
     * @param {*} options 
     * @param {*} options.url  跳转地址
     * @returns 用户地址
     */
    static getUserAddress(options) {
        const { address } = FuncEvents.getMobileUserinfo()
        if (address) {
            return address || ""
        } else {

            Login.goToWXPage({ url: '/pages/xd-yytPage/water-login' })

            return false

        }
    }

    /**
     * @title 获取主键
     */
    static getPrimaryKey() {
        return 'getPrimaryKey'
    }
    /**
     * @title 获取当前时间戳
     */
    static getDate() {
        const date = new Date()
        const year = date.getFullYear()
        const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : (date.getMonth() + 1)
        const day = date.getDay() < 10 ? `0${date.getDay()}` : date.getDay()
        const hour = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
        const seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()


        const dateString = `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`

        return dateString
    }
}

export class FuncEventConfig extends FuncEvents {
    static config = {
        // GETUSERINFO: {
        //     name: '获取用户信息',
        //     exec: this.getUserInfo,
        // },
        GETJGM: {
            name: '获取机构码',
            exec: this.getJGM,
        },
        GETUSERID: {
            name: '获取用户ID',
            exec: this.getUserId,
        },
        GETUSERADDRESS: {
            name: '获取用户地址',
            exec: this.getUserAddress,
        },
        GETPRIMARYKEY: {
            name: '获取主键',
            exec: this.getPrimaryKey,
        },
        GETDATE: {
            name: '获取年月日时分秒',
            exec: this.getDate
        }
    }
    /**
     * @title 以数组的形式返回
     * @returns 
     */
    static configArray() {
        let array = []
        for (const key in FuncEventConfig.config) {
            array.push({
                ...FuncEventConfig.config[key],
                type: key
            })
        }
        console.log('configArray', array)
        return array
    }
}




export class Login {
    static isMobile() {
        // 判断屏幕宽度小于等于 768px，并且用户代理字符串中包含手机设备标识
        return window.innerWidth <= 1200 && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    static setWxUrlLocalStorage() {
        if (!this.isMobile()) {
            return
        }

        const urlParams = Tools.getUrlParams()
        localStorage.setItem('mobileUserinfo', JSON.stringify(urlParams))

    }
    static navigateTo({ url }) {
        const { $wxsdk } = window.app.config.globalProperties

        // 跳转小程序登录
        $wxsdk.miniProgram.navigateTo({ url });
    }
    static goToWXPage({ url }) {
        this.navigateTo({ url })
    }

}